var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onlyDot)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"dot ml-2",style:({ backgroundColor: _vm.dotColor }),attrs:{"title":_vm.text}}):_c('span',{staticClass:"status"},[_c('span',{staticClass:"dot",style:({ backgroundColor: _vm.dotColor })}),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }